import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { castDraft, immerable, produce } from 'immer';
import { Set } from 'immutable';

export type TargetConsumer = {
	id: number;
	name: string;
	isGroup: boolean;
	avatar: AvatarEntity | null;
};

export interface IExpositionPreviousConsumerEntity {
	id: string;
	fullName: string;
	description: string;
	unRecognized: boolean;
	isGroup: boolean;
	avatar: AvatarEntity | null;
	targetConsumers: Set<TargetConsumer>;
}

const entityDefaults: IExpositionPreviousConsumerEntity = {
	id: '',
	fullName: '',
	description: '',
	unRecognized: true,
	isGroup: false,
	avatar: null,
	targetConsumers: Set(),
};

export class ExpositionConsumerMappingEntity
	implements IExpositionPreviousConsumerEntity
{
	private [immerable] = true;
	public id = entityDefaults.id;
	public isGroup = entityDefaults.isGroup;
	public avatar = entityDefaults.avatar;
	public fullName = entityDefaults.fullName;
	public description = entityDefaults.description;
	public unRecognized = entityDefaults.unRecognized;
	public targetConsumers = entityDefaults.targetConsumers;

	public static build(
		params: Partial<IExpositionPreviousConsumerEntity>
	): ExpositionConsumerMappingEntity {
		const instance = new ExpositionConsumerMappingEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.isGroup = params.isGroup ?? entityDefaults.isGroup;
		instance.fullName = params.fullName ?? entityDefaults.fullName;
		instance.description = params.description ?? entityDefaults.description;
		instance.unRecognized = params.unRecognized ?? entityDefaults.unRecognized;
		instance.targetConsumers =
			params.targetConsumers ?? entityDefaults.targetConsumers;

		if (!params.isGroup && params.fullName) {
			instance.avatar = AvatarEntity.build(params.fullName);
		}

		return instance;
	}

	public updateTargetConsumers(
		targetConsumers: Set<TargetConsumer>
	): ExpositionConsumerMappingEntity {
		return produce(this, (draft) => {
			draft.targetConsumers = castDraft(targetConsumers);
		});
	}
}
